/**
 * Centralized route definitions for the admin frontend
 * All route paths should be defined here and imported where needed
 */

import {
  CubeIcon,
  ShoppingBagIcon,
  TagIcon,
  BuildingOfficeIcon,
  UserGroupIcon,
  Cog6ToothIcon,
  MapPinIcon,
  StarIcon,
  ArrowPathIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";

export const ROUTES = {
  // Public routes
  LOGIN: "/login",
  REGISTER: "/register",

  // Protected routes
  DASHBOARD: "/", // Redirects to inventory
  INVENTORY: "/inventory",
  INVENTORY_ITEM_DETAIL: (itemId) => `/inventory/items/${itemId}`,
  INVENTORY_CREATE_ITEM: "/inventory/create",
  
  ORDERS: "/orders",
  ORDER_DETAIL: (orderId) => `/orders/${orderId}`,
    
  USERS: "/users",
  USER_DETAIL: (userId) => `/users/${userId}`,
  
  CATEGORY_MANAGEMENT: "/catalog/categories",
  INSTITUTION_MANAGEMENT: "/catalog/institutions",
  
  PURCHASE_DETAILS: "/purchase-details",
  SALES: "/sales",
  STORE: "/manage-store",
  SITE_SETTINGS: "/site-settings",
  STORE_ADDRESSES: "/store-addresses",
  RETURNS: "/returns",
  QUOTE_REQUESTS: "/quote-requests",
  REVIEWS: "/reviews",
};

/**
 * Navigation menu items configuration
 */
export const NAVIGATION_ITEMS = [
  {
    name: "Inventory",
    path: ROUTES.INVENTORY,
    icon: CubeIcon,
  },
  {
    name: "Orders",
    path: ROUTES.ORDERS,
    icon: ShoppingBagIcon,
  },
  {
    name: "Categories",
    path: ROUTES.CATEGORY_MANAGEMENT,
    icon: TagIcon,
  },
  {
    name: "Institutions",
    path: ROUTES.INSTITUTION_MANAGEMENT,
    icon: BuildingOfficeIcon,
  },
  {
    name: "Users",
    path: ROUTES.USERS,
    icon: UserGroupIcon,
  },
  {
    name: "Site Settings",
    path: ROUTES.SITE_SETTINGS,
    icon: Cog6ToothIcon,
  },
  {
    name: "Store Addresses",
    path: ROUTES.STORE_ADDRESSES,
    icon: MapPinIcon,
  },
  {
    name: "Reviews",
    path: ROUTES.REVIEWS,
    icon: StarIcon,
  },
  {
    name: "Returns",
    path: ROUTES.RETURNS,
    icon: ArrowPathIcon,
  },
  {
    name: "Quote Requests",
    path: ROUTES.QUOTE_REQUESTS,
    icon: DocumentTextIcon,
  },
];

export default ROUTES;

